const mapCardData = (data) => {
    if (!data) {
        return [];
    }

    const dataMapped = normalizePosition(data).map(card => {
        return {
            'id': card.id || null,
            'Label': card.Label || '',
            'Page': card.Page || null,
            'Position': card.Position || null,
            '_Position': card.Position || null,
            'Status': card.Status || '',
            'confirmed': card.Confirmed ? 'confirmed' : 'not-confirmed',
            'projection': card.projection || 0,
            'katalogProducts': card.katalogProducts || [],
            'isVirtual': card.isVirtual || false,
            'virtualFrom': card.virtualFrom || null,
            'isLoyalty': card.Type == 'loyalty',
            'Removed': card.Removed || false,
            'unreadCommentCount': card.unreadCommentCount || 0,
            'DesignerNote': card.DesignerNote || null,
            'isWebOnly': card.isWebOnly || false,
            'approved': card.approved || false,
            'maskType': card.masterMask.maskType || null,
            'LoyaltyMinItemCount': card.LoyaltyMinItemCount || null,
            'LoyaltyItemCount': card.LoyaltyItemCount || null,
            'LoyaltyGratisItemCount': card.LoyaltyGratisItemCount || null
        }
    })

    return dataMapped
}

/**
 * Normalize position of cards
 * Make sure that Positions always start from 1 and are consecutive
 * Also, store original position in _Position and keep received order of cards intact
 *
 * @param {Array} data Array of cards
 *
 * @returns Array of cards with normalized positions
 */
const normalizePosition = (data) => {
    const positions = data.map(card => card.Position).sort((a, b) => a - b);
    return data.map((card, index) => {
        return {
            ...card,
            _Position: card.Position,
            Position: positions.indexOf(card.Position) + 1
        }
    });
}

function mapCardDataOverview(data) {
    if (!data) return []

    const dataMapped = data.map(card => {
        return {
            'id': card.id || null,
            'Brand': card.Brand || null,
            'Label': card.Label || '',
            'displayMeasureValue': card.displayMeasureValue || '',
            'PriceFrom': card.PriceFrom || 0,
            'Price': card.Price || 0,
            'Percentage': card.Percentage || 0,
            'Images': card.Images || [],
            'showPriceWarning': card.showPriceWarning || false,
            'isLoyalty': card.Type == 'loyalty',
            'unreadCommentCount': card.unreadCommentCount || 0,
            'LowestPrice': card.LowestPrice || 0,
            'productCodes': card.productCodeImageMap || null,
            'priceOnDatePrice': card.priceOnDate.maximumPrice && card.priceOnDate.maximumPrice.price ? card.priceOnDate.maximumPrice.price : '-',
            'priceOnDateDate': card.priceOnDate.maximumPrice && card.priceOnDate.maximumPrice.date ? card.priceOnDate.maximumPrice.date : 'datum',
            'maskType': card.masterMask.maskType || null,
            'LoyaltyMinItemCount': card.LoyaltyMinItemCount || null,
            'LoyaltyItemCount': card.LoyaltyItemCount || null,
            'LoyaltyGratisItemCount': card.LoyaltyGratisItemCount || null,
            'loyaltyPrice': card.loyaltyPrice || null,
            'loyaltyPriceRegular': card.loyaltyPriceRegular || null,
            'loyaltyPercentage': card.loyaltyPercentage || null
        }
    })

    return dataMapped
}

function mapImageData(data) {
    if (!data) return []

    const dataMapped = data.map(image => {
        return {
            'id': image.id || null,
            'filename': image.filename || '',
            'origin': image.origin || '',
            'preview': image.preview || '',
            'thumbnail': image.thumbnail || ''
        }
    })

    return dataMapped
}

export { mapCardData, mapCardDataOverview }
